import { EVENTINSTANCE_FRAGMENT } from './fragments';
import { gql } from '@apollo/client';

export const EVENTINSTANCE_INSERT = gql`
  ${EVENTINSTANCE_FRAGMENT}
  mutation InsertOneEventInstance($data: CreateOneEventinstanceInput!) {
    insertOneEventinstance(data: $data) {
      ...EventInstanceFragment
    }
  }
`;

export const EVENTINSTANCE_UPDATE = gql`
  ${EVENTINSTANCE_FRAGMENT}
  mutation UpdateOneEventInstance(
    $eventInstanceId: MongoID!
    $data: UpdateByIdEventInstanceInput!
  ) {
    updateOneEventInstance(_id: $eventInstanceId, set: $data) {
      ...EventInstanceFragment
    }
  }
`;

export const EVENTINSTANCE_DELETE = gql`
  mutation DeleteEventInstance($eventInstanceId: MongoID!) {
    deleteOneEventinstance(_id: $eventInstanceId) {
      _id
    }
  }
`;

// export const EVENTINSTANCE_DIVISION_CREATE = gql`
//   mutation eventInstanceDivisionCreate(
//     $data: CreateOneEventinstancedivisionInput!
//   ) {
//     insertOneEventinstancedivision(data: $data) {
//       _id
//       name
//       description
//       maxParticipants
//       forIndividuals
//       forTeams
//       forUnderage
//       teamSize
//       minAge
//       maxAge
//       registrationFee
//       advancingAthletesNumber
//       advancingAthletesPercentage
//       assignedJudges
//       sequence
//       stripePriceId
//       earlyBirdPricing
//       earlyBirdRegistrationFee
//       earlyBirdDeadline
//       earlyBirdPriceStripePriceId
//     }
//   }
// `;

// export const EVENTINSTANCE_DIVISION_UPDATE = gql`
//   mutation updateInstanceEventDivision(
//     $eventInstanceDivisionId: MongoID!
//     $data: UpdateByIdEventinstancedivisionInput!
//   ) {
//     updateOneEventinstancedivision(_id: $eventInstanceDivisionId, set: $data) {
//       eventInstanceId
//       division {
//         name
//         description
//         maxParticipants
//         forIndividuals
//         forTeams
//         forUnderage
//         teamSize
//         minAge
//         maxAge
//         registrationFee
//         advancingAthletesNumber
//         advancingAthletesPercentage
//         assignedJudges
//         sequence
//         stripePriceId
//         earlyBirdPricing
//         earlyBirdRegistrationFee
//         earlyBirdDeadline
//         earlyBirdPriceStripePriceId
//       }
//     }
//   }
// `;

// export const EVENTINSTANCE_DIVISION_DELETE = gql`
//   mutation deleteInstanceDivision($eventInstanceDivisionId: MongoID!) {
//     deleteOneEventinstancedivision(_id: $eventInstanceDivisionId) {
//       status
//     }
//   }
// `;

export const EVENTINSTANCE_DIVISION_CREATE = gql`
  mutation eventInstanceDivisionCreate(
    $eventInstanceId: MongoID!
    $division: EventInstanceDivisionsInput!
  ) {
    addEventInstanceDivision(
      eventInstanceId: $eventInstanceId
      division: $division
    ) {
      _id
      name
      divisions {
        _id
        name
        description
        maxParticipants
        forIndividuals
        forTeams
        forUnderage
        teamSize
        minAge
        maxAge
        registrationFee
        advancingAthletesNumber
        advancingAthletesPercentage
        assignedJudges
        sequence
        stripeProductId
        stripePriceId
        earlyBirdPricing
        earlyBirdRegistrationFee
        earlyBirdDeadline
        earlyBirdPriceStripeProductId
        earlyBirdPriceStripePriceId
        createdAt
        updatedAt
      }
    }
  }
`;

export const EVENTINSTANCE_DIVISION_UPDATE = gql`
  mutation updateInstanceEventDivision(
    $eventInstanceId: MongoID!
    $divisionId: MongoID!
    $updates: UpdateByIdEventInstanceDivisionsInput!
  ) {
    updateEventInstanceDivision(
      eventInstanceId: $eventInstanceId
      divisionId: $divisionId
      updates: $updates
    ) {
      _id
      name
      divisions {
        _id
        name
        description
        maxParticipants
        forIndividuals
        forTeams
        forUnderage
        teamSize
        minAge
        maxAge
        applyAdaptiveRegistrationFee
        registrationFee
        advancingAthletesNumber
        advancingAthletesPercentage
        assignedJudges
        sequence
        stripeProductId
        stripePriceId
        earlyBirdPricing
        earlyBirdRegistrationFee
        earlyBirdDeadline
        earlyBirdPriceStripeProductId
        earlyBirdPriceStripePriceId
        createdAt
        updatedAt
      }
    }
  }
`;

export const EVENTINSTANCE_DIVISION_DELETE = gql`
  mutation deleteInstanceDivision(
    $eventInstanceId: MongoID!
    $divisionId: MongoID!
  ) {
    removeEventInstanceDivision(
      eventInstanceId: $eventInstanceId
      divisionId: $divisionId
    ) {
      _id
      name
      divisions {
        _id
        name
        description
      }
    }
  }
`;

// Query to get all divisions for an event instance
export const GET_EVENTINSTANCE_DIVISIONS = gql`
  query getEventInstanceDivisions($eventInstanceId: MongoID!) {
    eventinstanceById(_id: $eventInstanceId) {
      _id
      name
      divisions {
        _id
        name
        description
        maxParticipants
        forIndividuals
        forTeams
        forUnderage
        teamSize
        minAge
        maxAge
        registrationFee
        applyAdaptiveRegistrationFee
        advancingAthletesNumber
        advancingAthletesPercentage
        assignedJudges
        sequence
        stripeProductId
        stripePriceId
        earlyBirdPricing
        earlyBirdRegistrationFee
        earlyBirdDeadline
        earlyBirdPriceStripeProductId
        earlyBirdPriceStripePriceId
        createdAt
        updatedAt
      }
    }
  }
`;
